import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../store';

export function AdminOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user } = useSelector((state: RootState) => state.auth);
  const userType = (user as any)?.userType as 'ADMIN' | 'PRACTITIONER' | undefined;

  if (userType === 'PRACTITIONER') {
    return <Navigate to="/practitioner/dashboard" replace />;
  }

  return <>{children}</>;
}

export default AdminOnlyRoute;

